import { Html5QrcodeScanner, Html5QrcodeSupportedFormats } from 'html5-qrcode'
import { useEffect } from 'react'

const Scanner = ({ setCode = () => { }, setIsScanning = () => { } }) => {
  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      'reader',
      {
        fps: 30,
        qrbox: 200,
        formatsToSupport: [
          Html5QrcodeSupportedFormats.QR_CODE,
          Html5QrcodeSupportedFormats.EAN_13,
          Html5QrcodeSupportedFormats.CODE_128
        ]
      },
      false
    )

    scanner.render(
      (decodedText) => {
        setCode({ target: { value: decodedText } })
        setIsScanning(false)
      },
      (error) => {
        console.log('errore:', error)
      }
    )

    return () => scanner.clear()
  }, [])

  return (
    <div>
      <div
        id="reader"
      />
    </div>
  )
}

export default Scanner